module.exports = __webpack_public_path__ + "static/media/univer pardubice.cb9c45ed.png";